<template>
  <div class="tw-m-auto tw-max-w-default-container tw-bg-white tw-p-16 tw-rounded-lg tw-flex tw-flex-col">
    <slot />
  </div>
</template>
